import React, { useState, useEffect } from 'react';
import newIcon from '../Asset/non-active-icon/newIcon.svg';
import { Link,useNavigate } from 'react-router-dom';
import moment from 'moment';
import Alert from './Alert';
import { getUserInfo } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import {environment} from './functions/environment';

function Notification() {
    let navigate = useNavigate();
    let userObj = getUserInfo();
    //let notification = [{notificationID:1},{notificationID:2}]
    let [sessOut,setSessOut] = useState(false);
    let [notification, setNotification] = useState([]);
    let [alert, setAlert] = useState({
        msg: "test",
        status: false
    });
    //console.log(notification)
    useEffect(() => {
        getNotifications();
    }, [])
    function getNotifications() {
        fetch(environment.baseUrl + 'getNotificationsByUser', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((resp) => {
            resp.json().then((res) => {
                if (res.code == 200) {
                    //console.log(res.data.result.notifications)
                    setNotification(res.data.result.notifications)
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setNotification([]);
                }
            })
        })
    }
    function markAsRead(id) {

        // console.log("from mark as read");
        fetch(environment.baseUrl + 'readNotifications', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({ notificationArray: [id] })
        }).then((resp) => {
            resp.json().then((res) => {
                setAlert({
                    msg: res.msg,
                    status: true
                });
                getNotifications();
            })
        })
    }
    function getNotiData(msg,asset,id)
    {
        markAsRead(id);
        let divideString = msg.split(":")
        let geoName = divideString[2].trim();
        let loc = divideString[1].split(" ")
        let log = parseFloat(loc[1].split(",")[0]);
        let lat = parseFloat(loc[1].split(",")[1].substring(0,loc[1].split(",")[1].length - 1));
         console.log("log:",geoName,log,lat);
        // let obj = {
        //     geoName:geoName,
        //     loc:[log,lat],
        //     asset:asset
        // }
        navigate(`/assetlocation/${geoName}/${log+","+lat}/${asset}`)
        // navigate(`/assetlocation/${JSON.stringify(obj)}`)
    }
    return (
        <div className='main-container'>
            <SessionFun show = {sessOut}></SessionFun>
            <Alert obj={alert} />
            <h4 className='main-heading'>Notification</h4>
            <p className='short-link'><Link to='/'>Home&nbsp;<i className='fa fa-angle-right'></i></Link>&nbsp; Notification</p>

            <div className="row mt-3">

                {
                    notification.length ?
                        (notification).map((item,index) =>
                            <div className="col-sm-12 card-box-block mb-2"  key={index} >
                                <div className="row" style={{cursor:'pointer'}} onClick={()=>{getNotiData(item.notificationMessage,item.assetID,item.notificationID)}}>
                                    <div className="col-sm-6">
                                        <h5><b>{item.notificationTitle}</b>{!item.isRead ? <img src={newIcon} className="ms-2" height="17" alt="" /> : ""} </h5>

                                    </div>
                                    <div className="col-sm-6 text-end">
                                        {moment(item.createdDateTime).format('lll')}
                                    </div>
                                    <div className="col-sm-12 noti-msg">
                                        <p>Equipment ID : {item.assetID}</p>
                                        <p>{item.notificationMessage}</p>
                                    </div>
                                </div>
                                    {/* <div className="col-sm-12 text-end">
                                        <button className="btn btn-link" onClick={()=>markAsRead(item.notificationID,index)}>Mark as read</button>
                                    </div> */}
                                    {
                                        !item.isRead ?
                                        <div className="row">
                                            <div className="col-sm-12 text-end">
                                                <button className="btn btn-link" onClick={() => { markAsRead(item.notificationID) }}>Mark as read</button>
                                            </div>
                                        </div>
                                        : ""
                                    }

                                </div>
                        ) :
                        <div className="col-sm-12 card-box-block mb-2 text-center">
                            <p><b>Not Available</b></p>
                        </div>
                }

            </div>
        </div>
    )
}

export default Notification
